<template>
  <div class="basic-course">
    <div class="basic-course-banner">
      <PageBanner
        :title="basicCourseBannerInfo.title"
        :desc="basicCourseBannerInfo.desc"
      >
        <template slot="right-content">
          <img src="~/assets/image/page-top-banner/basic-course.png" alt="" />
        </template>
      </PageBanner>
    </div>

    <div class="basic-course-filter">
      <page-filter
        :data="filterArr"
        @first-click="handleFirstClick"
      ></page-filter>
    </div>

    <template v-if="postData">
      <div class="basic-course-list">
        <VideoCourse
          v-for="(item, index) in postData.list"
          :key="index"
          :data="item"
          @click="handleVideoClick(item)"
        />
      </div>
    </template>
  </div>
</template>

<script>
// office基础课视频
import { SORT_FILTER } from '@/common/constant/filter-tabs';
import VideoCourse from '@/components/common/video-course/video-course';
import PageBanner from '@/components/page-banner/index';
import mixinAsyncData from '@/common/mixin/mixin-async-data';
import { query2Search } from '@/common/utils';
import PageFilter from '@/components/page-filter';

async function asyncData({ params, query, app }) {
  const { sort = 'hot', tgId = '' } = query;
  const page = query.page ? +query.page : 1;
  const cgId = params.cgId ? +params.cgId : null;
  const pageSize = 25;

  const [categoryMenuRes, tagMenuRes, postRes] = await Promise.all([
    app.$service.learning.getBasicCourseCategoryList(),
    app.$service.learning.getBasicCourseTagList(),
    app.$service.learning.getBasicCourseVideoList({
      category_id: cgId,
      tag_id: tgId,
      sort,
      page,
      pageSize,
    }),
  ]);

  const categoryMenu = categoryMenuRes && categoryMenuRes.data;
  const tagMenu = tagMenuRes && tagMenuRes.data;
  const postData = postRes && postRes.data;

  return {
    cgId,
    tgId,
    postData,
    page,
    pageSize,
    sort,
    categoryMenu,
    tagMenu,
  };
}

// banner图信息
const basicCourseBannerInfo = {
  title: '精选办公技巧合集，从0基础到精通Office',
  desc: 'Office基础系列课',
};
export default {
  head() {
    let header = this.$head.defaultHead();
    return header;
  },
  mixins: [mixinAsyncData(asyncData)],
  name: 'basic-course',
  components: {
    VideoCourse,
    PageBanner,
    PageFilter,
  },
  data() {
    return {
      cgId: '',
      tgId: '',
      categoryMenu: null, // 基础课分类
      tagMenu: null, // 基础课标签
      postData: { list: [] },
      sort: 'hot',
      page: 1,
      pageSize: 25,
      basicCourseBannerInfo,
      basePath: '/learning/office/index/cg',
    };
  },
  computed: {
    filterArr() {
      return [
        {
          name: '分类',
          value: this.categoryValue,
          list: this.categoryList,
        },
        {
          name: '标签',
          value: this.tagValue,
          list: this.tagList,
        },
        {
          name: '排序',
          value: this.sort,
          list: this.sortList,
        },
      ];
    },
    categoryValue({ cgId }) {
      if (!cgId) return null;
      return cgId;
    },
    categoryList({ categoryMenu }) {
      let res = [];
      res.push({
        name: '全部',
        value: null,
        url: `${this.basePath}`,
      });
      categoryMenu &&
        categoryMenu.length &&
        categoryMenu.forEach((item) => {
          res.push({
            name: item.name,
            value: item.id,
            url: `${this.basePath}/${item.id}`,
          });
        });
      return res;
    },
    tagValue({ tgId }) {
      if (!tgId) return null;
      return Number(tgId);
    },
    tagList({ cgId, tagMenu }) {
      let res = [];
      const { query = {} } = this.$route;
      let url = cgId ? `${this.basePath}/${cgId}` : this.basePath;
      res.push({
        name: '全部',
        value: null,
        url: url,
      });
      tagMenu &&
        tagMenu.length &&
        tagMenu.forEach((item) => {
          res.push({
            name: item.tag_name,
            value: item.id,
            url: `${url}${query2Search({
              ...query,
              tgId: item.id
            })}`,
          });
        });
      return res;
    },
    sortList({ cgId }) {
      const { query = {} } = this.$route;
      let url = cgId ? `${this.basePath}/${cgId}` : this.basePath;
      return SORT_FILTER.map((item) => {
        return {
          ...item,
          url: `${url}${query2Search({
            ...query,
            sort: item.value
          })}`
        };
      });
    },
  },
  methods: {
    handleFirstClick(item, subItem) {
      if ((item.name = '分类')) {
        this.$collect.officeCourseClick({
          click: 'class',
          keyword: subItem.name,
        });
      } else if ((item.name = '标签')) {
        this.$collect.officeCourseClick({
          click: 'tag',
          keyword: subItem.name,
        });
      }
    },
    handleVideoClick(item) {
      this.$collect.officeCourseClick({ click: 'content', type: item.id });
    },
    afterMounted() {
      if (!this.postData || (this.postData.list && Array.isArray(this.postData.list) && this.postData.list.length == 0)) { // 如果list为空则表示筛选项错误，统一跳回首页
        this.$router.push('/learning')
      }
      this.$collect.officeCourseShow({ show: 'base' });
    }
  }
};
</script>

<style lang="scss" scoped>
.basic-course {
  margin-top: 10px;

  &-banner {
    padding: 0 12px;
  }

  &-filter {
    padding: 32px 0;
    border-bottom: 1px solid rgba(17, 19, 23, 0.1);
    margin: 0 12px 20px 12px;
  }

  &-list {
    display: flex;
    flex-flow: row wrap;
  }

  .pagination {
    margin-top: 56px;
  }
}
</style>
